export enum SIGN_IN_CORE {
    EMAIL_NOT_RECEIVED = 'EMAIL_NOT_RECEIVED',
    LOGIN_GENERIC_SIGN_IN = 'LOGIN.GENERIC_SIGN_IN',
    POWERED_BY = 'LOGIN_POWERED_BY',
    TRY_ANOTHER_ADDRESS = 'TRY_ANOTHER_ADDRESS',
}
